'use strict';

/**
 * Verifica il supporto o meno dei placeholder html nei diversi browser
 * @returns {boolean}
 */
module.exports = function supportPlaceholder() {
    return 'placeholder' in document.createElement('input');
};
